<template>
    <div class="insights-about">
        <main>
            <section class="about-us">
                <div class="container">
                    <div class="row">
                        <div class="col-12 ml-auto col-lg-10 mr-auto">
                            <h1>About Us</h1>
                            <p>In the last ten years there’s been a boom in intelligent non-fiction, and there’s a good reason for that.</p>
                            <p>In a turbulent world of competing views and fake news, along with the distractions of social media, it pays to go deeper. Books give you the lowdown on a person, issue, or idea that you just can’t get from other sources.</p>
                            <p>We help you to extract and gain that knowledge.</p>
                            <p>Our Book Insights have been written by experts in their field, including some bestselling authors.</p>
                            <p>The team builds on the knowledge of Tom Butler-Bowdon, author of the bestselling 50 Classics series looking at the key books in personal development, the social sciences and philosophy. Our editors have deep knowledge across non-fiction and have selected books that aim to inspire, inform, or entertain - hopefully all three.</p>
                            <p>We have an in-house audio production team, and work with talented professional narrators.</p>
                        </div>
                    </div>
                </div>
                <div class="about-us-image">
                    <div class="container">
                        <h2>We hope you’ll become part<br>of our knowledge community!</h2>
                    </div>
                    <img class="w-100" src="@assets/img/book-insights/about-us-bg.jpg" alt="About us graphic">
                </div>
            </section>
            <section class="who-we-are">
                <div class="container">
                    <div class="row">
                        <div class="col-12 ml-auto col-lg-10 mr-auto">
                            <h3>Who We Are</h3>
                            <h4>Your Book Insights Team</h4>
                            <div class="row">
                                <div
                                    v-for="(collaborator, index) in collaborators"
                                    :key="index"
                                    class="col-12 col-md-6"
                                    @click="() => expandedCollaboratorBio = collaborator.name"
                                >
                                    <collaborator-bio
                                        :collaborator="collaborator"
                                        :expand-collaborator="expandedCollaboratorBio"
                                        @close-bio="() => expandedCollaboratorBio = ''"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <memod-footer />
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "AboutUs",
    components: {
        memodFooter: () => import(/* webpackChunkName: "memod-footer"*/ "@v/memod-footer"),
        collaboratorBio: () => import(/* webpackChunkName: "collaborator-bio"*/ "@c/collaborator-bio")
    },
    data() {
        return {
            expandedCollaboratorBio: ""
        }
    },
    computed: {
        ...mapState({
            collaborators: state => state.AboutTeam.collaborators
        })
    }
}
</script>

<style lang="scss">
.insights-about {
    padding-top: 134px !important;

    .about-us {
        @media (max-width: $lg) {
            img {
                width: 100%;
            }
        }

        @media (max-width: $md) {
            .about-us-image {
                margin-right: unset !important;
                margin-left: auto;

                img {
                    width: initial;
                }
            }
        }

        @media (max-width: $sm) {
            .about-us-image {
                img {
                    width: 180%;
                }
            }
        }

        h1 {
            font-size: 45px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.11;
            letter-spacing: 0.4px;
            margin-bottom: 30px;
            text-align: center;

            @media (max-width: $sm) {
                font-size: 23px;
                font-weight: 600;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.26;
                letter-spacing: 0.4px;
            }
        }

        p {
            font-size: 16px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.53;
            letter-spacing: 0.4px;
            color: white;
        }

        h2 {
            font-size: 22px;
            font-weight: 600;
            font-stretch: normal;
            line-height: 1.22;
            letter-spacing: 0.4px;
            color: #505050;
            margin-top: 30px;
            color: white;

            @media (max-width: $sm) {
                font-size: 26px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 1.22;
                letter-spacing: 0.4px;
            }
        }
    }

    .about-us-image {
        position: relative;
        max-height: 700px;
        overflow: hidden;
        display: flex;
        align-items: center;

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgb(0,0,0);
            background: linear-gradient(0deg, rgba(2,2,2,1) 0%, rgba(0,0,0,0.5) 50%, rgba(2,2,2,1) 100%);
        }

        .container {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 100px;

            h2 {
                text-align: right;
            }

            @media (max-width: $md) {
                bottom: 0;
            }
        }
    }

    .who-we-are {
        h3 {
            font-size: 27px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.3;
            letter-spacing: 0.4px;
            color: white;
            margin-bottom: 0px;
            text-align: center;

            @media (max-width: $sm) {
                font-size: 20px;
                font-weight: 600;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.45;
                letter-spacing: 0.4px;
                color: white;
            }
        }

        h4 {
            font-size: 23px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 0.4px;
            color: white;
            margin-bottom: 30px;
            text-align: center;
        }
    }
}
</style>
